import { render, staticRenderFns } from "./CompContestDetailCard.vue?vue&type=template&id=e0d8d832&scoped=true"
import script from "./CompContestDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContestDetailCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d8d832",
  null
  
)

export default component.exports